export const generalInfo = {
	title: "INFORMACIÓN GENERAL",
	fields: {
		image: {
			label: "Imagen del producto",
			ariaLabel: "Subir imagen del producto",
		},
		name: {
			label: "Nombre",
			placeholder: "Nombre del producto",
		},
		productType: {
			label: "Tipo de producto",
			placeholder: "Seleccionar tipo",
			loading: "Cargando...",
		},
		sku: {
			label: "SKU",
			placeholder: "Ingrese el SKU",
			tooltip:
				"SKU (Unidad de Mantenimiento de Stock) es un código único para identificar el producto. Si no lo completas, generaremos uno automáticamente.",
		},
		category: {
			label: "Categoría",
			placeholder: "Seleccionar una categoría",
		},
		menuCategory: {
			label: "Categoría del menú",
			placeholder: "Seleccionar categoría del menú",
		},
		preparationTime: {
			label: "Tiempo de preparación",
			placeholder: "00 minutos",
			tooltip:
				"Ingresa el tiempo que tarda la cocina en preparar este producto en minutos",
			unit: "minutos",
		},
		description: {
			label: "Descripción",
			placeholder: "Escriba una descripción breve",
		},
		hasAlcohol: {
			label: "¿Contiene alcohol?",
			tooltip: "Al activarlo, aparecerá en el menú para clientes que contiene alcohol",
			yes: "sí",
			no: "no",
		},
	},
	noCategory: "Sin categoría",
};
